var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMcYlogoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 36",
    style: {
      enableBackground: "new 0 0 100 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#58B431;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.46,11.91v-0.72c0-1.32-0.42-1.72-1.8-1.72h-4.66c-1.38,0-1.8,0.4-1.8,1.72v3.59 c0,1.32,0.42,1.72,1.8,1.72h4.66c1.38,0,1.8-0.4,1.8-1.72v-0.92h-1.8V15h-4.65v-4.1h4.65v1.01H70.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.73,9.47V15h-4.3V9.47h-1.8v5.31c0,1.32,0.42,1.72,1.8,1.72h4.3c1.38,0,1.8-0.4,1.8-1.72V9.47H78.73z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "97.56,9.47 95.38,11.9 93.2,9.47 90.8,9.47 94.47,13.38 94.47,16.49 96.28,16.49 96.28,13.38  99.96,9.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "39.26,9.47 36.43,13.47 33.59,9.47 31.87,9.47 31.87,16.49 33.64,16.49 33.64,12.16 35.71,15.21  37.14,15.21 39.21,12.16 39.21,16.49 40.98,16.49 40.98,9.47  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.82,13.92h0.6c1.13,0,1.64-0.44,1.64-1.43v-1.6c0-0.99-0.51-1.43-1.64-1.43h-5.94v7.03h1.77v-5.64h3.46 c0.48,0,0.61,0.09,0.61,0.44v0.82c0,0.35-0.12,0.44-0.61,0.44h-2.29v1.32l3.21,2.63h2.34L57.82,13.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.85,13.92h0.6c1.13,0,1.64-0.44,1.64-1.43v-1.6c0-0.99-0.51-1.43-1.64-1.43h-5.94v7.03h1.77v-5.64h3.46 c0.48,0,0.61,0.09,0.61,0.44v0.82c0,0.35-0.12,0.44-0.61,0.44h-2.29v1.32l3.21,2.63H91L87.85,13.92z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "50.43,10.84 50.43,9.47 43.21,9.47 43.21,16.49 50.43,16.49 50.43,15 45.01,15 45.01,13.52  49.73,13.52 49.73,12.15 45.01,12.15 45.01,10.84  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "42.56,24.92 42.56,19.5 40.79,19.5 40.79,26.39 47.56,26.39 47.56,24.92  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "72.54,19.5 72.54,20.9 75.61,20.9 75.61,26.39 77.37,26.39 77.37,20.9 80.45,20.9 80.45,19.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.07,19.5h-4.91c-1.35,0-1.76,0.39-1.76,1.68v3.52c0,1.29,0.41,1.68,1.76,1.68h4.91 c1.35,0,1.76-0.39,1.76-1.68v-3.52C89.83,19.9,89.42,19.5,88.07,19.5z M88.06,20.9v4.02h-4.91V20.9H88.06z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "64.06,19.5 61.39,24.23 58.72,19.5 56.82,19.5 60.71,26.39 62.06,26.39 65.96,19.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.92,23.87h0.58c1.11,0,1.61-0.43,1.61-1.4V20.9c0-0.97-0.5-1.4-1.61-1.4h-5.82v6.89h1.74v-5.52h3.39 c0.47,0,0.59,0.09,0.59,0.42v0.8c0,0.34-0.12,0.42-0.59,0.42h-2.25v1.29l3.12,2.55l0.03,0.02H100L96.92,23.87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "69.87,19.56 69.84,19.5 68.17,19.5 64.28,26.39 66.18,26.39 69.01,21.38 71.81,26.33 71.84,26.39  73.74,26.39  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "38.98,20.83 38.98,19.47 31.87,19.47 31.87,26.39 38.98,26.39 38.98,24.91 33.64,24.91  33.64,23.46 38.29,23.46 38.29,22.11 33.64,22.11 33.64,20.83  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "56.13,20.83 56.13,19.47 49.02,19.47 49.02,26.39 56.13,26.39 56.13,24.91 50.8,24.91 50.8,23.46  55.45,23.46 55.45,22.11 50.8,22.11 50.8,20.83  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.15,6.67c4.3,0,8.29,0.83,11.61,2.25L13.15,3.26L1.55,8.92C4.86,7.5,8.85,6.67,13.15,6.67z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "25.89,14.98 25.89,9.47 13.6,15.67 13.6,32.59 25.89,26.39 25.89,22.03 17.96,26.03 17.96,25.26  25.89,21.26 25.89,15.75 17.96,19.75 17.96,18.98  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0.42,9.47 0.42,26.39 3.85,28.12 3.85,17.35 4.54,17.7 4.54,28.47 8.05,30.25 8.05,19.48  8.74,19.82 8.74,30.59 12.71,32.59 12.71,15.67  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcYlogoGreen);
export default __webpack_public_path__ + "static/media/MCYlogo_green.d4a20a45f8082de848df6f7dd3af018a.svg";
export { ForwardRef as ReactComponent };